import { render, staticRenderFns } from "./DouyinBindGuide.vue?vue&type=template&id=e525d6c2&scoped=true"
import script from "./DouyinBindGuide.vue?vue&type=script&lang=js"
export * from "./DouyinBindGuide.vue?vue&type=script&lang=js"
import style0 from "./DouyinBindGuide.vue?vue&type=style&index=0&id=e525d6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e525d6c2",
  null
  
)

export default component.exports